import {
ThemeProvider as NextThemesProvider,
type ThemeProviderProps,
} from 'next-themes'

// One-time migration (2026-07-07): the app default changed from "system" to
// "light", but next-themes persisted the old default into localStorage on
// every browser that ever loaded the app — those would silently stay dark.
// Rewrite a stored "system" to "light" once; after that, an explicit System
// choice from the toggle sticks.
;(function migrateDefaultThemeToLight() {
  try {
    if (typeof window === 'undefined') return
    const MIGRATION_KEY = 'rp_theme_default_light_v1'
    if (localStorage.getItem(MIGRATION_KEY)) return
    if (localStorage.getItem('theme') === 'system') {
      localStorage.setItem('theme', 'light')
    }
    localStorage.setItem(MIGRATION_KEY, '1')
  } catch {
    // localStorage unavailable — the provider default still applies.
  }
})()

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
